import React from "react"
import Layout from "../components/Global/Layout/Layout"
import HeroSection from "../components/BlogPage/HeroSection/HeroSection"
import Tabs from "../components/BlogPage/Tabs/Tabs"
import { graphql } from "gatsby"
import SEO from "../components/Global/SEO/seo"
import { prefixStatamicAssetUrl } from "../utils/statamicAssets"

const blogAll = ({ data, pageContext }) => {
  const entries = (data && data.statamic && data.statamic.entries && data.statamic.entries.data) || []
  const posts = entries
    .filter((node) => !(node.blog_categories || []).some((c) => c && c.slug === "internal"))
    .map((node) => ({
      node: {
        id: node.id,
        title: node.title,
        slug: node.slug,
        publishedOn: node.published_on,
        externalLink: node.external_link,
        previewImage: node.preview_image
          ? {
              url: prefixStatamicAssetUrl(
                node.preview_image.permalink || node.preview_image.url
              ),
              title: node.preview_image.alt || node.title,
            }
          : null,
        category: (node.blog_categories || []).map((c) => ({
          slug: c.slug,
          name: c.title,
        })),
      },
    }))

  return (
    <Layout>
      <SEO page="blog" />
      <HeroSection />
      <Tabs
        posts={posts}
        showFeatured={false}
        showCategory={false}
        pageContext={pageContext}
      />
    </Layout>
  )
}

export default blogAll

export const query = graphql`
  query GetAllStagPosts($humanPageNumber: Int!, $limit: Int!) {
    statamic {
      entries(
        collection: "blog_posts"
        page: $humanPageNumber
        limit: $limit
        sort: "published_on desc"
      ) {
        data {
          id
          title
          slug
          ... on Statamic_Entry_BlogPosts_BlogPost {
            published_on(format: "d F Y")
            external_link
            preview_image {
              url
              permalink
              ... on Statamic_Asset_Assets {
                alt
                width
                height
              }
            }
            blog_categories {
              slug
              title
            }
          }
        }
        total
        current_page
        has_more_pages
      }
    }
  }
`
